import React, {useContext, useEffect, useMemo} from "react";
import UserPhoneHomepageProducts from "../products";
import classnames from "classnames";
import {Fade, Tooltip} from "@mui/material";
import UserPhoneHomepageTimeBasedTimer from "./timer";
import {UserHomepageControllerContext, UserHomepageStateContext, UserHomepageViewContext} from "../../../../../../index";
import {UserHomepageControllerEvents, UserHomepageEventEmitter, UserHomepageViewMode} from "../../../../../../models";
import UserHomepageUtils from "../../../../../../core/utils";

const UserPhoneHomepageTimeBased = ({component, tabId, bodyId}) => {
    const viewContext = useContext(UserHomepageViewContext);
    const {viewMode} = useContext(UserHomepageStateContext);
    const controller = useContext(UserHomepageControllerContext);

    /** @type{boolean} */
    const showMoreButton = useMemo(() =>
            (!!component.searchQuery && viewMode === UserHomepageViewMode.preview) ||
            (viewMode === UserHomepageViewMode.edit),
        [viewMode, component?.searchQuery])
    /** @type{boolean}*/
    const moreButtonInvisible = useMemo(() =>
            viewMode === UserHomepageViewMode.edit && !component.nexusSearchId,
        [viewMode, component?.nexusSearchId])

    /**
     * With each change in the controller:
     * - attaches the event listeners for component and content selection for focusing purposes.
     */
    useEffect(() => {
        controller.on(UserHomepageControllerEvents.onComponentSelected, focusComponent)
        return () => {
            controller.off(UserHomepageControllerEvents.onComponentSelected, focusComponent)
        }
    }, [controller, component, viewContext])

    /**
     * Scrolls the component into the view as a result of control panel selection of the component
     * @param {UserHomepageEventEmitter} emitter
     * @param {number} tabId
     * @param {number} componentId
     */
    const focusComponent = (emitter, tabId, componentId) => {
        if (componentId !== component.id)
            return;
        const body = document.getElementById(bodyId);
        body.scrollTo({
            top: document.getElementById(component.phoneViewElementId).offsetTop - body.offsetTop,
            left: 0,
        })
    }

    /**
     * Invokes the appropriate controller callback for the click of the time based more button.
     */
    const onMoreButtonClicked = () => {
        controller.selectComponentSearchButton(tabId, component.id, UserHomepageEventEmitter.view);
    }

    /**@type {JSX.Element}*/
    const moreButton = useMemo(() => (
        <button
            onClick={onMoreButtonClicked}
            className={classnames('user-phone-homepage-more-button', {'not-visible': moreButtonInvisible})}>
            More
        </button>
    ), [moreButtonInvisible])

    return (
        <>
            <div className={'user-phone-homepage-time-based products-container'}>
                <Fade in={showMoreButton}>
                    <div className={'d-flex justify-content-end w-100'}>
                        {
                            moreButtonInvisible
                                ? <Tooltip
                                    title={'No search query or search type specified'}
                                >
                                    {moreButton}
                                </Tooltip>
                                : moreButton
                        }
                    </div>
                </Fade>
                <div className={'component-title'}>
                    <p>
                        Deal Ends In
                    </p>
                </div>
                <UserPhoneHomepageTimeBasedTimer
                    endDate={UserHomepageUtils.getTimeBasedFinishDateTime(component)}
                />
                <UserPhoneHomepageProducts component={component} tabId={tabId} hideHeader/>
            </div>
        </>
    );
}


export default UserPhoneHomepageTimeBased;
